// Utility function to normalize locale codes for JS APIs (e.g., toLocaleDateString)
// Usage: normalizeLocale('es_us') => 'es-US'

export function normalizeLocale(locale) {
  if (!locale) return 'en-US'
  let loc =
    typeof locale === 'symbol' ? locale.toString().replace(/^:/, '') : locale
  loc = loc.replace('_', '-')
  if (loc === 'en') return 'en-US'
  if (loc === 'es') return 'es-US'
  return loc.replace(/-([a-z]{2})$/i, (_, p1) => '-' + p1.toUpperCase())
}
